import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

// Esquema de validación Yup
const schema = yup.object().shape({
  tipcomcod: yup
    .string()
    .required("El código es obligatorio")
    .length(2, "Debe tener exactamente 2 caracteres"),
  tipcomabr: yup
    .string()
    .required("La abreviatura es obligatoria")
    .length(1, "Debe tener exactamente 1 caracter"),
  tipcomnom: yup.string().required("El nombre es obligatorio"),
  tipcomdes: yup.string().max(255, "Máximo 255 caracteres"),
});

const ComprobanteTypeForm = ({ open, handleClose, onSubmit, defaultValues = {} }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  useEffect(() => {
    if (open) {
      reset(defaultValues);
    }
  }, [open, defaultValues, reset]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {defaultValues?.tipcomid ? "Editar Tipo de Comprobante" : "Crear Tipo de Comprobante"}
      </DialogTitle>

      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Código"
                fullWidth
                {...register("tipcomcod")}
                error={!!errors.tipcomcod}
                helperText={errors.tipcomcod?.message}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Abreviatura"
                fullWidth
                {...register("tipcomabr")}
                error={!!errors.tipcomabr}
                helperText={errors.tipcomabr?.message}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Nombre del Comprobante"
                fullWidth
                {...register("tipcomnom")}
                error={!!errors.tipcomnom}
                helperText={errors.tipcomnom?.message}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Descripción"
                fullWidth
                multiline
                rows={2}
                {...register("tipcomdes")}
                error={!!errors.tipcomdes}
                helperText={errors.tipcomdes?.message}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type="submit" variant="contained">
            {defaultValues?.tipcomid ? "Actualizar" : "Guardar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ComprobanteTypeForm;
